export default "__VITE_ASSET__Wx0vPtLK__"